import { render, staticRenderFns } from "./ButtonNewUser.vue?vue&type=template&id=1d9e641f&scoped=true&lang=pug&"
import script from "./ButtonNewUser.vue?vue&type=script&lang=ts&"
export * from "./ButtonNewUser.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonNewUser.vue?vue&type=style&index=0&id=1d9e641f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e641f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
